import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { AlertConfirmService } from '../../services/alert-confirm.service';
import { DataService } from '../../services/data.service';
import { ShortEncryptorService } from '../../services/short-encryptor.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule],
  providers: [DatePipe],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  datePipe = inject(DatePipe);
  curYear = new Date().getFullYear();
  fin_period = [
    {"code": "2024", "name": "2024-25"},
    {"code": "2025", "name": "2025-26"},
    {"code": "2026", "name": "2026-27"},
    {"code": "2027", "name": "2027-28"},
    {"code": "2028", "name": "2028-29"},
    {"code": "2029", "name": "2029-30"}
  ];
  model = { 'erp_key': '', 'user_name': '', 'password': '', 'session': this.curYear };
  error = '';
  loading = false;
  remember = false;
  user: any = null;
  erp_key4sub = '';
    
  constructor(
    private auth: AuthService, 
    private router: Router, 
    private route: ActivatedRoute,
    private alertService: AlertConfirmService, 
    public dataService: DataService, 
    private shCrypt: ShortEncryptorService
  ) {
    //
  }

  async ngOnInit() {
    this.route.paramMap.subscribe((params: any) => {
      const erp_key = params.get('ekey');
      if(erp_key) {
        this.model = { 'erp_key': erp_key, 'user_name': 'mwcc', 'password': 'mw@punjab', 'session': this.curYear };
        this.submit();
      }
    });

    let erp_rem: any = localStorage.getItem("erp_rem");

    if(erp_rem) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;
      if(this.user.user_name != 'mwcc') {
        this.model.erp_key = this.user.erp_key || '';
        this.model.user_name = this.user.user_name;
        this.model.session = this.user.session || this.curYear;
        this.remember = true;
      }
    }

    // If user already logged in
    if(this.user && !this.user.subscribe) {
      // const userx = this.shCrypt.decrypt(this.user.user_name);
      // if((userx == 'trial' && this.user.is_active) || this.user.erp_key.substr(0, 4)=='DEMO') {
      //   this.router.navigate(['/dashboard/'+this.dataService.myEncrypt('trial')]);
      // } else {
      //   this.router.navigate(['/dashboard']);
      // }
      // if(this.user.user_role[0].code != 'spr' && this.user.user_name != 'mwcc') {
      //   await this.dataService.getSingleRecord('my_package', this.user.erp_key).then((res: any) => {
      //     this.dataService.my_modules = res || [];
      //     sessionStorage.setItem('my_modules', JSON.stringify(res));
      //   });
      // }

      if(this.user?.erp_key && this.user?.erp_key.substr(0,4)=="DEMO") {
        this.router.navigate(['/dashboard/'+this.dataService.myEncrypt('trial')]);
      } else {
        this.router.navigate(['/dashboard/home']);
      }
    }
  }

  submit() {
    this.error = '';
    this.loading = true;

    this.auth.login(this.model).subscribe({
      next: async (res: any) => {
        if(res) {
          if(typeof res.user.user_role == 'string') {
            res.user.user_role = this.dataService.str2json(res.user.user_role);
          }

            const curDate: Date = new Date();
            const expDate: Date = new Date(res.user.exp_date);
            const dayRemains = this.dataService.getDaysDiff(curDate, expDate);

            if(dayRemains < 0) {
              this.loading = false; 
              this.user = Object.assign({}, res.user);

              if(res.user.user_role[0].code == 'onr' || res.user.user_role[0].code == 'adm' || res.user.user_role[0].code == 'acc') {
                // await this.dataService.getSingleRecord('my_package', res.user.erp_key).then((res: any) => {
                //   this.dataService.my_modules = res || [];
                //   sessionStorage.setItem('my_modules', JSON.stringify(res));
                // });

                delete this.user.user_role;
                delete this.user.is_active;
                this.user.subscribe = true;
                localStorage.setItem("erp_rem", JSON.stringify(this.user));
                this.router.navigate(['/institute']);
              } else {
                this.alertService.alert(
                  'Attention!',
                  'Can not be proceed to login for now, please contact to Institute / ERP Admin.',
                  'danger'
                );
              }
            } else {
              if(typeof res.user.user_role == 'string') {
                res.user.user_role = this.dataService.str2json(res.user.user_role);
              }

              // if(res.user.user_role[0].code != 'spr') {
              //   await this.dataService.getSingleRecord('my_package', res.user.erp_key).then((res: any) => {
              //     this.dataService.my_modules = res || [];
              //     sessionStorage.setItem('my_modules', JSON.stringify(res));
              //   });
              // }

              // const userx = this.shCrypt.decrypt(res.user.user_name);
              // if((userx == 'trial' && res.user.is_active) || (res.user.erp_key && res.user.erp_key.substr(0, 4)=='DEMO')) {
              if((res.user.erp_key && res.user.erp_key.substr(0, 4)=='DEMO')) {
                res.user = this.dataService.enCodeUser(res.user);
                localStorage.setItem("erp_rem", JSON.stringify(res.user));
                this.router.navigate(['/dashboard/'+this.dataService.myEncrypt('trial')]);
              } else {
                res.user = this.dataService.enCodeUser(res.user);
                localStorage.setItem("erp_rem", JSON.stringify(res.user));

                // set activity log details
                this.dataService.setActivityLog('login', 'auth', 'User login to erp.');

                this.router.navigate(['/dashboard/home']);
              }
            }

        }
      },
      error: (err: any) => {
        this.loading = false; 

        if(err.error.code == "ENETUNREACH") {
          this.error = "Unable to connect to the server. Make sure your internet is working.";
        } else {
          this.error = err?.error?.message || 'Invalid username or password.';
        }

        this.alertService.alert(
          'Error!',
          this.error,
          'danger'
        );
      }
    });
  }

  async proceed2subscribe() {
    if(this.erp_key4sub) {
      this.model = { 'erp_key': this.erp_key4sub, 'user_name': '', 'password': '', 'session': this.curYear };
      this.submit();
    }
  }

}
